import { Translate } from 'next-translate';

export const formatParameterValue = (valueText: string, isLogicalType: boolean | undefined, t: Translate) => {
    return isLogicalType ? (valueText === '1' ? t('Yes') : t('No')) : valueText;
};
